<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2024-01-02 16:34:05
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\system\custom\components\detialCustom.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer v-loading.fullscreen="loading" :visible="visible" size="70%" :destroy-on-close="true"
    :wrapper-closable="false" :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
    <div slot="title" style="display: flex;justify-content: space-between;">
      <div>查看</div>
      <div>
        <el-button @click="$emit('close')"> 返回 </el-button>
      </div>
    </div>
    <el-form ref="form" :model="form" label-width="140px">
      <div class="box-title">客户信息</div>
      <el-form-item label="客户名称">
        {{ form.customer }}
      </el-form-item>
      <el-form-item label="客户联系人">
        {{ form.customerName }}
      </el-form-item>
      <el-form-item label="客户地址">
        {{ form.customerAddress }}
      </el-form-item>
      <div class="box-title">收件地址</div>
      <div style="margin-top: 8px;">
        <div v-for="domain in form.customerRecipientVoList" :key="domain.key" class="container">
          <el-form-item label="收件人姓名">
            {{ domain.name }}
          </el-form-item>
          <el-form-item label="收件人区域">
            {{ domain.recipientArea }}
          </el-form-item>
          <el-form-item label="收件人详细地址">
            {{ domain.address }}
          </el-form-item>
          <el-form-item label="收件人电话">
            {{ domain.telephone }}
          </el-form-item>
        </div>

      </div>

    </el-form>
  </el-drawer>
</template>

<script>
import { getCustomInfo } from '@/api/system/custom'
import { regionData } from 'element-china-area-data'

export default {
  name: 'DetialCustom',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    customInfo: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      regionData,
      form: {},
    }
  },
  created() {
    if (this.customInfo.id) {
      this.getInfo(this.customInfo.id)
    }
  },
  // 方法集合
  methods: {
    // 获取出入库记录
    getInfo(id) {
      getCustomInfo(id).then((res) => {
        const {
          customerRecipientVoList
        } = res.data
        this.form = JSON.parse(JSON.stringify(res.data))

        customerRecipientVoList.forEach((item, index) => {
          const list = ['provinceName', 'cityName', 'countyName']
          customerRecipientVoList[index].recipientArea = list.map(key=>item[key]).join('')
          customerRecipientVoList[index].key = Math.random()
        })

        // 转换数据
        for (const key in this.form) {
          if (res.data[key]) {
            this.form[key] = res.data[key]
          }
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  padding: 12px 8px;
  background: #F2F2F2;
  position: relative;
  width: 60%;
  margin: 0 12px 12px;

  .remove {
    font-size: 20px;
    z-index: 999;
    position: absolute;
    cursor: pointer;
    top: 4px;
    right: 5px;
  }

}
</style>
